import Image from 'next/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import s from './MediaMapList.module.sass'
import clsx from 'clsx'
import type { getMediaItems } from '../utilities/getMediaItem'
import { createSlug } from '../utilities/getMediaItem'

export type MediaMapListProps = {
	items: Awaited<ReturnType<typeof getMediaItems>>
}

export const MediaMapList: FunctionComponent<MediaMapListProps> = ({ items }) => {
	return (
		<div className={s.List}>
			{items &&
				items.length > 0 &&
				items.map((item, index) => (
					<Mapping
						key={`${item.slug}-${index}`}
						screenshot={item.detail_o_webu.screenshot[0]}
						nazev={item.detail_o_webu.nazev[0]}
						adresa_webu={item.detail_o_webu.adresa_webu[0]}
					/>
				))}
		</div>
	)
}

const Mapping: FunctionComponent<{
	nazev: string
	screenshot?: string
	adresa_webu?: string
}> = ({ screenshot, nazev, adresa_webu }) => {
	return (
		<div className={clsx(s.Wrapper)}>
			<div className={s.Item}>
				<Link href={`/map/${createSlug(nazev)}/`} className={s.Link} />
				<div className={s.ImageWrapper}>
					{screenshot?.includes('http') && (
						<Image src={screenshot} alt={nazev ?? ''} width={216} height={121} className={s.Image} />
					)}
				</div>
			</div>
			<div className={s.Content}>
				<h3 className={s.TileTitle}>{nazev}</h3>
				{adresa_webu && (
					<Link href={adresa_webu} className={s.Site}>
						{adresa_webu}
					</Link>
				)}
			</div>
		</div>
	)
}
